import gql from 'graphql-tag'

import PersonalizationOptions from '@Queries/cms/fragments/PersonalizationOptions.fragment'
import PriceFragment from '@Queries/cms/fragments/Price.fragment'

export default gql`
  ${PersonalizationOptions}
  ${PriceFragment}

  fragment ProductCrossSellAndPersonalizationContent on Product {
    id
    type
    name
    url
    brand {
      title
    }
    primaryAsset: asset(tag: "primary") {
      url
      tags
    }
    moneyShotAsset: asset(tag: "money_shot") {
      url
      tags
    }
    masterVariant {
      id
      ...PersonalizationOptions
      price {
        ...PriceFragment
      }
    }
  }
`
